import { PayrollCyclesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { useIncidenceFilterContext } from 'modules/bookkeepers/lib/IncidenceFilterContext'

const useGetCycleCount = () => {
  const { selectedCompany, filterDate } = useIncidenceFilterContext()

  const { loading, data: cyclesData } = useQuery(PayrollCyclesDocument, {
    variables: {
      companyIds: [selectedCompany?.id],
      dateFrom: filterDate.firstDate,
      dateTo: filterDate.lastDate,
    },
    context: {
      isBookkeeperView: true,
    },
  })

  const cyclesCount = cyclesData?.compensations.payrollRunsConnection.totalCount ?? 0

  return {
    loading,
    cyclesCount,
  }
}

export default useGetCycleCount
